import { useState } from "react";

import useWorkspaces from "common/datahooks/useWorkspaces";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AgencySubscriptionCard from "../../AgencySubscriptionCard";
import AgencyLicenseSummary from "./AgencyLicenseSummary";
import DesktopTable from "./DesktopTable";
import MobileList from "./MobileLayout/MobileList";

export default function PlanDetails() {
  const isDesktop = useTwBreakpoint("lg");
  const { workspaces } = useWorkspaces();

  const [editingWorkspaceId, setEditingWorkspaceId] = useState<string>();

  const filteredWorkspaces = workspaces
    ? workspaces.filter(({ role }) => role === "owner")
    : [];

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <>
      <AgencySubscriptionCard isAgencyPage />
      <AgencyLicenseSummary isCompact={false} />
      <Component
        workspaces={filteredWorkspaces}
        editingWorkspaceId={editingWorkspaceId}
        setEditingWorkspaceId={setEditingWorkspaceId}
      />
    </>
  );
}
